import axios from "axios";
import React, { Component } from "react";
import { baseURL } from "../../../../constants/applicationConstants.js";
import { Loader } from "../../../common/loader/loader.jsx";
import ExpertAnswerJsx from './expertAnswer.jsx'
import { emailRegex, nameRegex } from '../../../../shared/helper.js';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';

export default class ExpertAnswer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: {
                answer: ''
            },
            questionData: null,
            answerData: null,
            isLoading: false,
            formError: {},
            page:1
        }
    }
    onPaginationButtonClick = (page) => {
        window.scrollTo(0,0);
        this.setState({ page: page })
    }

    componentDidMount = () => {
        this.getAnsweredData();
    }

    giveAnswer = (index, action) => {
        let tempArr = [...this.state.questionData];
        tempArr[index] = { ...tempArr[index], isOpen: action }
        this.setState({ questionData: tempArr })
    }
    sendAnswer = (value,id) => {
        const userInput = document.getElementsByName(`answer${value}`)[0].value;  // Use this as value of textare
        this.setState({
            isLoading: true
        })


        const payloadData = {
            answer: userInput
        }

        let token = localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"))

            axios.put(`${baseURL}/allocateAskExpertQuestionResponse/${id}`, payloadData, {
                headers: { 'x-access-token': token }
            }).then(res => {
                if (res.data.success) {
                    toast.success("Data Updated Successfully!")
                    this.setState({
                        isLoading: false
                    })
                   
                    this.getQuestionData()
                    // window.location.reload()
                }
                else {
                    toast.error(res.data.error.message)
                    this.setState({
                        isLoading: false
                    })
                }

            }).catch(err => {
                toast.error(err.response.data.error.message)
                this.setState({
                    isLoading: false
                })
            })
        
    }


    getQuestionData = () => {
        let token = JSON.parse(localStorage.getItem('token'));
        let expertId = JSON.parse(localStorage.getItem("masterID"));
        this.setState({ isLoading: true })

        axios.get(`${baseURL}/expert/${expertId}/assignedQuestions?status=not-answered`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ questionData: res.data.data})
        }).catch(err=>{
            this.setState({ isLoading: false })
          })
    }
    getAnsweredData = () => {
        let token = JSON.parse(localStorage.getItem('token'));
        let expertId = JSON.parse(localStorage.getItem("masterID"));
        this.setState({ isLoading: true })

        
        this.getQuestionData();

        axios.get(`${baseURL}/expert/${expertId}/assignedQuestions?status=answered`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            this.setState({ answerData: res.data.data, isLoading: false })
        }).catch(err=>{
            this.setState({ isLoading: false })
          })
    }
    inputRegexValidation = (name, value) => {
        if (name === 'email')
            return emailRegex.test(value);
        else if (name === 'firstName' || name === 'lastName')
            return nameRegex.test(value);


        return false;
    };

    onInputChangeHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (value) {
            if (!this.inputRegexValidation(name, value)) {
                this.setState(
                    {
                        userData: {
                            ...this.state.userData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "regx",
                        },
                    },

                );
            } else {
                this.setState(
                    {
                        userData: {
                            ...this.state.userData,
                            [name]: value,
                        },
                        formError: {
                            ...this.state.formError,
                            [name]: "",
                        },
                    },

                );
            }
        } else {
            this.setState(
                {
                    userData: {
                        ...this.state.userData,
                        [name]: value,
                    },
                    formError: {
                        ...this.state.formError,
                        [name]: "",
                    },
                },

            );
        }
    };

    render() {
        return (
            <div>
                <ExpertAnswerJsx questionData={this.state.questionData}
                answerData={this.state.answerData}
                    sendAnswer={this.sendAnswer}
                    onInputChangeHandler={this.onInputChangeHandler}
                    giveAnswer={this.giveAnswer}
                    onServiceSave={this.onServiceSave}
                    userData={this.state.userData}
                    onPaginationButtonClick={this.onPaginationButtonClick}
                    page={this.state.page}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}